module.exports = __webpack_public_path__ + "staticV3/img/509d6988.time-fail.png";